import { render, staticRenderFns } from "./KnowYourCustomer.vue?vue&type=template&id=0538a10f&scoped=true&"
import script from "./KnowYourCustomer.vue?vue&type=script&lang=js&"
export * from "./KnowYourCustomer.vue?vue&type=script&lang=js&"
import style0 from "./KnowYourCustomer.vue?vue&type=style&index=0&id=0538a10f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0538a10f",
  null
  
)

export default component.exports